const state = {
    productType: null,
  };
  
  const mutations = {
    SET_PRODUCT_TYPE: (state, productType) => {
      state.productType = productType;
    },
   
  };
  
  const getters = {
    productType: (state) => state.productType,
  };
  
  const entryProducts = {
    state,
    getters,
    mutations,
  };
  
  export default entryProducts;
  